import "./FaucetSinkRepair.module.css";
import Header from "@/reusable_sections/Header";
import FaucetSinkHero from "./sections/FaucetSinkHero";
import FaucetRepair from "./sections/FaucetRepair";
import FaucetProblems from "./sections/FaucetProblems";
import WarningSigns from "./sections/WarningSigns";
import FaucetDiagnostics from "./sections/FaucetDiagnostics";
import RelatedServices from "./sections/RelatedServices";
import RelatedProblems from "./sections/RelatedProblems";
import ServiceArea from "./sections/ServiceArea";
import FaucetFaq from "./sections/FaucetFaq";
import RequestCta from "./sections/RequestCta";
import Footer from "@/reusable_sections/Footer";
export default function FaucetSinkRepairPage() {
  return <div>
      <Header />
      <FaucetSinkHero />
      <FaucetRepair />
      <FaucetProblems />
      <WarningSigns />
      <FaucetDiagnostics />
      <RelatedServices />
      <RelatedProblems />
      <ServiceArea />
      <FaucetFaq />
      <RequestCta />
      <Footer />
    </div>;
}